export const longNumberFormatter = new Intl.NumberFormat('en', {
  notation: 'standard',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export const numberFormatter = new Intl.NumberFormat('en', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export function getPercentage(value: number, total: number) {
  return total === 0 ? 0 : (value / total) * 100;
}

export const dollarsFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatCentsToDollars(cents: number) {
  return dollarsFormatter.format(cents / 100);
}

const timeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'always', style: 'narrow' });

export function formatDays(days: number) { // example: 1 day, 38 days, 89 days, 106 days, 150 days, 360 days, 365 days, 730 days
  // Remove the "in" prefix that RelativeTimeFormat adds

  if (days < 2) {
    const hours = Math.round(days * 24);
    return timeFormatter.format(hours, 'hour').replace(/^in /, '');
  }

  if (days < 90) return timeFormatter.format(days, 'day').replace(/^in /, '');

  if (days < 365) return timeFormatter.format(Math.floor(days / 30), 'month').replace(/^in /, '');

  return timeFormatter.format(Math.floor(days / 365), 'year').replace(/^in /, '');
}

export function formatHours(hours: number) {
  if (hours < 25) {
    return timeFormatter.format(hours, 'hour').replace(/^in /, '');
  }

  return timeFormatter.format(Math.floor(hours / 24), 'day').replace(/^in /, '');
}
